import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useIntl } from 'react-intl';
import messages from './messages';

import { getStyles } from './styles';
import SubSidebar from './sidebar';
import { InvalidAccess } from '../../../../utils/sessionDataHandle';
import { useAppContext } from '../../../../context/AppContext';

import GeneralSettings from '../ChatbotHome';
import ChatbotDataset from '../ChatbotDataset';
import ChatbotBranding from '../ChatbotBranding';
import ChatbotAuthentication from '../ChatbotAuthentication';
import ChatbotLaunch from '../ChatbotLaunch';
import { useDispatch, useSelector } from 'react-redux';
import { setAgentApiTokenState, setAnalyticsDataSetsState } from '../../../../Redux/slice/dataSlice';
import { setAgentApiTokenAdded, setAnalyticsAppsAdded, setAnalyticsDataSetAdded } from '../../../../Redux/slice/newDataSlice';
import { fetchAccountId, fetchSubscriberId, fetchSubscriptionId, fetchThirdPartyToken, fetchThirdPartyTokenProvider } from '../../../../utils/GetAccountDetails';
import AnalyticsApi from '../../../../Api/Services/AmeyaBackend/AnalyticsToolApi';
import { tostAlert } from '../../../../utils/AlertToast';
import { apiErrorHandler } from '../../../../utils/ApiErrorHandler';
import moment from 'moment';
import AiAppsApi from '../../../../Api/Services/AppflyteBackend/AiAppsApi';
import { checkProject } from '../../../../utils';
import LoadBar from '../../../../utils/LoadBar';
import getAnalyticsDataSetsData from '../../../../utils/ApiFunctions/AnalyticsDataSetsData';
import ChatBotLoader from '../../../../components/ChatBotLoader';
import ProjectsApi from '../../../../Api/Services/AppflyteBackend/ProjectsApi';
import {
    AdvancedChatConfig, SimpleChatConfig,
    AdvancedChatPreview, SimpleChatPreview
} from '../ChatConfigs';
import handleFileUpload from '../../../../utils/fileUpload';
import { ANALYTICS_S3_BUCKET_CHATBOT_LOGO, ANALYTICS_S3_BUCKET_FOLDER, ANALYTICS_S3_BUCKET_SCRIPT_FILE } from '../../../../utils/constants';
import { getProjectAgentApiTokens } from '../../../../utils/ApiFunctions/AgentAPiTokenData';

let s3_foldername = ANALYTICS_S3_BUCKET_FOLDER
let s3_file_name = ANALYTICS_S3_BUCKET_SCRIPT_FILE
let s3_logo_name = ANALYTICS_S3_BUCKET_CHATBOT_LOGO

function AddChatbot() {

    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const styles = getStyles(theme);
    const dispatch = useDispatch();
    const intl = useIntl();
    const { selectedOrganization, selectedWorkspace, selectedProject, appDetails, setAppDetails, ameyaChatBotAppDetails, handleAnalyticsSteps } = useAppContext();
    const [selectedMenuItem, setSelectedMenuItem] = useState(0);
    const [unlockedSteps, setUnlockedSteps] = React.useState([0]);

    const [allTokens, setAllTokens] = useState([]);
    const [datasets, setDatasets] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [tokenLoading, setTokenLoading] = useState(false);
    const [datasetLoading, setDatasetLoading] = useState(false);
    const [chatbotLoading, setChatbotLoading] = useState(false);

    const all_agent_api_tokens = useSelector(state => state.all_data.agent_api_tokens)
    const agent_api_token_added = useSelector(state => state.data_added.agent_api_token_added)
    const analytics_data_sets = useSelector(state => state.all_data.analytics_data_sets);
    const analytics_data_set_added = useSelector(state => state.data_added.analytics_data_set_added);

    useEffect(() => {
        if (!selectedWorkspace || !selectedProject) {
            InvalidAccess(navigate);
            return
        }
        //eslint-disable-next-line
    }, [location.pathname, navigate]);

    const handleMenuChange = (engine, path) => {
        if (engine && path) {
            navigate(`/create-ai-app/${engine?.toLowerCase()?.replace(/_/g, '-')}/${path?.toLowerCase()?.replace(/_/g, '-')}`);
        }
    };

    useEffect(() => {
        getAllData()
        //eslint-disable-next-line
    }, [])

    const getAllData = async () => {
        setDataLoading(true)
        try {
            await Promise.all([getAllTokensDetails(), getDatasets()])
        } catch (error) {
            console.log(error)
        } finally {
            setDataLoading(false)
        }
    }

    const getAllTokensDetails = async () => {
        setTokenLoading(true)
        let all_tokens = []
        try {
            if (all_agent_api_tokens?.length > 0 && agent_api_token_added === false) {
                all_tokens = all_agent_api_tokens
            } else {
                const organization_id = selectedOrganization?.payload?.__auto_id__;
                const project_id = selectedProject?.payload?.__auto_id__;
                const response = await getProjectAgentApiTokens(organization_id, project_id);
                all_tokens = response
                dispatch(setAgentApiTokenState(response))
                dispatch(setAgentApiTokenAdded(false))
            }
            const filtered_tokens = (all_tokens || []).filter(token => token?.payload?.token_type === "admin_generate_token") ?? [];
            setAllTokens(filtered_tokens)
            return;
        } catch (error) {
            console.log(error)
            return
        } finally {
            setTokenLoading(false)
        }
    }

    const getDatasets = async () => {
        setDatasetLoading(true)
        try {
            if ((analytics_data_sets || [])?.length > 0 && analytics_data_set_added === false) {
                setDatasets(analytics_data_sets)
            } else {
                const response = await getAnalyticsDataSetsData(selectedProject?.payload?.__auto_id__);
                dispatch(setAnalyticsDataSetsState(response))
                dispatch(setAnalyticsDataSetAdded(false))
                setDatasets(response)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setDatasetLoading(false)
        }
    }

    const createApp = async (app_id, app_name, app_description, app_logo, datasetIds) => {
        try {

            const projectId = selectedProject?.payload?.__auto_id__ ?? null;
            const appObj = {
                "collection_item": {
                    "__auto_id__": app_id,
                    "app_id": app_id,
                    "name": app_name,
                    "description": app_description,
                    "app_logo": app_logo,
                    "datasets": datasetIds,
                    "type": "ANSWERING BOT",
                    "project_id": projectId,
                    "created_on": moment().format("DD-MM-YYYY HH:mm:ss")
                }
            }
            const response = await AiAppsApi.createApp(JSON.stringify(appObj))
            if (response.status === 200) {
                return true
            }
            return false
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const createAnalyticsApp = async (app_id, app_name, app_description, datasetIds) => {
        try {
            const appObj = {
                "app_name": app_name,
                "app_id": app_id,
                "app_description": app_description,
                "dataset_ids": datasetIds
            }
            const response = await AnalyticsApi.createAiApp(JSON.stringify(appObj))
            if (response.status === 200) {
                return true
            }
            return false
        } catch (error) {
            console.log(error)
            return false
        }
    }

    function updateExtractionProjects(extraction_projects = [], an_project_id, app_id) {
        (async () => {
            const updates = extraction_projects.map(project_id => {
                const payload = {
                    id: project_id,
                    fields: [
                        { path: "$.analytics_app_id", value: app_id },
                        { path: "$.analytics_project_id", value: an_project_id }
                    ]
                };

                return ProjectsApi.updateProject(JSON.stringify(payload), project_id, null);
            });
            await Promise.allSettled(updates);
        })();
    }

    const handleSave = async () => {
        setDataLoading(true)
        try {
            const app_id = appDetails?.app_id ?? uuid();
            const app_name = appDetails?.app_name ?? '';
            const app_description = appDetails?.app_description ?? '';
            const app_bot_type = appDetails?.app_bot_type ?? 'simple_bot';
            const app_launch_icon = appDetails?.app_launch_icon ?? 'chatlaunch1';
            const selectedLogo = appDetails?.appLogoData?.selectedLogo ?? null;
            const welcome_message = appDetails?.welcome_message ?? '';
            const default_dataset = appDetails?.default_dataset?.payload?.dataset_id ?? null;
            const project_id = selectedProject?.payload?.__auto_id__;
            const llm_type = appDetails?.authConfigData?.llm_type ?? "gemini";

            if (!app_name) {
                tostAlert(intl.formatMessage(messages.field_check), 'warning')
                navigate("/create-ai-app/analytics-tool/chatbot-home")
                return
            }

            const dataset = appDetails?.dataset || [];
            const datasetIds = (dataset || [])?.map(item => item?.payload?.dataset_id) ?? [];
            const extraction_projects = (dataset || []).flatMap(item => item?.payload?.extraction_projects ?? []);

            if (dataset?.length === 0 || datasetIds?.length === 0) {
                tostAlert(intl.formatMessage(messages.field_check), 'warning')
                navigate("/create-ai-app/analytics-tool/datasets")
                return
            }

            const { ...rest } = appDetails?.chatStylesData ?? {};
            if (Object.values(rest).some(v => v === null || v === undefined || v === "")) {
                tostAlert(intl.formatMessage(messages.field_check), 'warning');
                navigate("/create-ai-app/analytics-tool/branding");
                return null;
            }

            const feedback_status = appDetails?.chatFeedbackData?.feedback_status === "true";
            const feedback_url = appDetails?.chatFeedbackData?.feedback_url ?? "";
            if (feedback_status && !feedback_url.trim()) {
                tostAlert(intl.formatMessage(messages.field_check), 'warning')
                navigate("/create-ai-app/analytics-tool/branding");
                return
            }

            let auth_type = appDetails?.authConfigData?.auth_type ?? "no_auth";
            if (app_bot_type === 'simple_bot') {
                auth_type = "no_auth";
            }

            const service_agent_token = appDetails?.authConfigData?.service_agent_token ?? null;
            if (!service_agent_token) {
                tostAlert(intl.formatMessage(messages.field_check), 'warning')
                navigate("/create-ai-app/analytics-tool/security")
                return
            }

            const account_id = await fetchAccountId();
            const subscriber_id = await fetchSubscriberId();
            const subscription_id = await fetchSubscriptionId();

            const appflyte_account_configs = {
                account_id: account_id,
                subscriber_id: subscriber_id,
                subscription_id: subscription_id,
                schema_id: window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID,
                project_id: project_id
            }

            const api_url_config = {
                appflyte_backend_base_url: window.__ENV__.APPFLYTE_BACKEND_URL,
                analytics_base_url: window.__ENV__.ANALYTICS_SERVICE_URL
            }

            let app_logo_name = null;
            if (selectedLogo) {
                const file_type = selectedLogo?.name?.split('.')[1];
                app_logo_name = `${s3_foldername}/${s3_logo_name}/${subscriber_id}/${subscription_id}/${project_id}/${app_id}.${file_type}`;
                const logo_response = await handleFileUpload(app_logo_name, selectedLogo);
                if (logo_response.status !== 200) {
                    tostAlert(intl.formatMessage(messages.create_error), 'error');
                    return
                }
            }

            const analytics_app_response = await createAnalyticsApp(app_id, app_name, app_description, datasetIds);
            if (!analytics_app_response) {
                tostAlert(intl.formatMessage(messages.create_error), 'error');
                return
            }

            const dpod_ai_app = await createApp(app_id, app_name, app_description, app_logo_name, datasetIds);
            if (!dpod_ai_app) {
                tostAlert(intl.formatMessage(messages.create_error), 'error');
                return
            }


            (extraction_projects || [])?.length > 0 && updateExtractionProjects(extraction_projects, project_id, app_id)

            const chatbotConfig = {
                WELCOME_MESSAGE: welcome_message || "",
                APP_DETAILS: {
                    app_id: app_id || "",
                    app_name: app_name || "",
                    app_description: app_description || "",
                    app_bot_type: app_bot_type,
                    app_launch_icon: app_launch_icon,
                    app_logo_name: app_logo_name || "",
                    feedback_status: feedback_status,
                    feedback_url: feedback_url
                },
                APPFLYTE_ACCOUNT_CONFIGS: appflyte_account_configs || {},
                API_URL_CONFIGS: api_url_config || {},
                SOURCE_DETAILS: {
                    default_dataset: default_dataset,
                    datasets: datasetIds
                },
                UI_CONFIGS: appDetails?.chatStylesData || {},
                AUTHENTICATION_CONFIGS: {
                    auth_type: auth_type,
                    llm_type: llm_type,
                    service_agent_user_token_id: service_agent_token?.__auto_id__ || "",
                    service_agent_user_token: service_agent_token?.token || ""
                }
            }

            const chatEmbedd_file = app_bot_type === "simple_bot" ? SimpleChatConfig(chatbotConfig) : AdvancedChatConfig(chatbotConfig);
            const blob = new Blob([chatEmbedd_file], { type: "application/javascript" });
            const filename = `${s3_foldername}/${s3_file_name}/${subscriber_id}/${subscription_id}/${project_id}/${app_id}.js`;
            const file = new File([blob], filename, { type: "application/javascript" });
            const response = await handleFileUpload(filename, file);
            if (response.status === 200) {
                handleAnalyticsSteps('analytics_app_link_dataset_status')
                tostAlert(intl.formatMessage(messages.configuration_success), 'success');
                dispatch(setAnalyticsAppsAdded(true))
                navigate('/ai-apps')
            }
            else {
                tostAlert(intl.formatMessage(messages.create_error), 'error');
                dispatch(setAnalyticsAppsAdded(true))
                navigate('/ai-apps')
            }

        } catch (error) {
            console.log(error)
            apiErrorHandler(error)
        } finally {
            setDataLoading(false)
        }
    }

    useEffect(() => {
        if (selectedMenuItem === 0) {
            navigate('/create-ai-app/analytics-tool/chatbot-home');
        }
        //eslint-disable-next-line
    }, [selectedMenuItem])

    function handleNext(path) {

        setUnlockedSteps(prev => {
            const next = selectedMenuItem + 1;
            if (!prev.includes(next)) return [...prev, next];
            return prev;
        });

        setSelectedMenuItem(selectedMenuItem + 1);

        switch (path) {
            case 'datasets':
                navigate('/create-ai-app/analytics-tool/datasets')
                break;
            case 'branding':
                navigate('/create-ai-app/analytics-tool/branding')
                break;
            case 'security':
                navigate("/create-ai-app/analytics-tool/security");
                break;
            case 'test-launch':
                navigate('/create-ai-app/analytics-tool/test-launch')
                break;
            default:
                navigate('/ai-apps')
        }
    }

    function handleCancel() {
        navigate('/ai-apps')
        setAppDetails(ameyaChatBotAppDetails)
    }

    const loadChatBot = async (chatBotData) => {
        try {
            const scriptId = "analytics-script";
            const existingScript = document.getElementById(scriptId);

            if (existingScript) {
                console.log("Removing existing analytics script...");
                existingScript.remove();
            }

            const app_bot_type = appDetails?.app_bot_type ?? 'simple_bot';
            let newScript = null;
            if (app_bot_type === 'advanced_bot') {
                newScript = await AdvancedChatPreview(chatBotData);
            } else {
                newScript = await SimpleChatPreview(chatBotData);
            }

            const script = document.createElement("script");
            script.id = scriptId;
            script.type = "text/javascript";
            script.textContent = newScript;
            document.body.appendChild(script);

            return script;
        } catch (error) {
            console.error("Error loading chatbot:", error);
            return null;
        }
    };

    const handleChatbotToggle = async () => {
        setChatbotLoading(true)
        try {
            const third_party_token = await fetchThirdPartyToken();
            const token_provider = await fetchThirdPartyTokenProvider()

            const app_id = appDetails?.app_id ?? '';
            const app_name = appDetails?.app_name ?? '';
            const app_description = appDetails?.app_description ?? '';
            const app_bot_type = appDetails?.app_bot_type ?? 'simple_bot';
            const app_launch_icon = appDetails?.app_launch_icon ?? 'app_launch_icon';
            const selectedLogo = appDetails?.appLogoData?.selectedLogo ?? null;
            const welcome_message = appDetails?.welcome_message ?? '';
            const llm_type = appDetails?.authConfigData?.llm_type ?? "gemini";

            const account_id = await fetchAccountId();
            const subscriber_id = await fetchSubscriberId();
            const subscription_id = await fetchSubscriptionId();
            const project_id = selectedProject?.payload?.__auto_id__;
            const default_dataset = appDetails?.default_dataset?.payload?.dataset_id ?? null;
            const dataset = appDetails?.dataset || [];
            const datasetIds = (dataset || [])?.map(item => item?.payload?.dataset_id) ?? [];
            let app_logo_name = null;

            if (!app_name) {
                tostAlert(intl.formatMessage(messages.field_check), 'warning')
                navigate("/create-ai-app/analytics-tool/chatbot-home")
                return
            }

            if (dataset?.length === 0 || datasetIds?.length === 0) {
                tostAlert(intl.formatMessage(messages.field_check), 'warning')
                navigate(`/create-ai-app/analytics-tool/datasets`)
                return
            }

            const feedback_status = appDetails?.chatFeedbackData?.feedback_status === "true";
            const feedback_url = appDetails?.chatFeedbackData?.feedback_url ?? "";
            if (feedback_status && !feedback_url.trim()) {
                tostAlert(intl.formatMessage(messages.field_check), 'warning')
                navigate("/create-ai-app/analytics-tool/branding");
                return
            }

            let auth_type = appDetails?.authConfigData?.auth_type ?? "no_auth";
            if (app_bot_type === 'simple_bot') {
                auth_type = "no_auth";
            }

            const service_agent_token = appDetails?.authConfigData?.service_agent_token ?? null;
            if (!service_agent_token) {
                tostAlert(intl.formatMessage(messages.field_check), 'warning')
                navigate(`/create-ai-app/analytics-tool/security`)
                return
            }

            await checkProject(project_id);

            if (!third_party_token) {
                tostAlert(intl.formatMessage(messages.auth_error), 'warning')
                return;
            }

            if (selectedLogo) {
                const file_type = selectedLogo?.name?.split('/')?.pop()?.split('.')?.pop() ?? null;
                if (!file_type) {
                    tostAlert(intl.formatMessage(messages.lauch_error), 'error');
                }
                app_logo_name = `${s3_foldername}/${s3_logo_name}/${subscriber_id}/${subscription_id}/${project_id}/${app_id}.${file_type}`;
                const logo_response = await handleFileUpload(app_logo_name, selectedLogo);
                if (logo_response.status !== 200) {
                    tostAlert(intl.formatMessage(messages.lauch_error), 'error');
                    return
                }
            }

            const chatBotData = {
                "WELCOME_MESSAGE": welcome_message,
                "APP_DETAILS": {
                    "app_id": app_id,
                    "app_name": app_name,
                    "app_description": app_description,
                    "app_bot_type": app_bot_type,
                    "app_launch_icon": app_launch_icon,
                    "app_logo_name": app_logo_name,
                    "feedback_status": feedback_status,
                    "feedback_url": feedback_url
                },
                "APPFLYTE_ACCOUNT_CONFIGS": {
                    "account_id": account_id,
                    "subscriber_id": subscriber_id,
                    "subscription_id": subscription_id,
                    "schema_id": window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID,
                    "project_id": project_id
                },
                "API_URL_CONFIGS": {
                    "appflyte_backend_base_url": window.__ENV__.APPFLYTE_BACKEND_URL,
                    "analytics_base_url": window.__ENV__.ANALYTICS_SERVICE_URL
                },
                "SOURCE_DETAILS": {
                    "default_dataset": default_dataset,
                    "datasets": datasetIds
                },
                "UI_CONFIGS": appDetails?.chatStylesData || {},
                "AUTHENTICATION_CONFIGS": {
                    "auth_type": auth_type,
                    "llm_type": llm_type,
                    "service_agent_user_token_id": service_agent_token?.__auto_id__,
                    "service_agent_user_token": service_agent_token?.token
                },
            }

            const script_load = await loadChatBot(chatBotData);
            if (!script_load) {
                tostAlert(intl.formatMessage(messages.lauch_error), 'warning');
            } else {
                if (app_bot_type === 'advanced_bot') {
                    setTimeout(() => {
                        if (window.toggleChatbotPreview) {
                            window.toggleChatbotPreview(token_provider, third_party_token);
                        } else {
                            tostAlert(intl.formatMessage(messages.lauch_error), 'warning');
                        }
                    }, 50);
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setChatbotLoading(false)
        }
    }

    return (
        <Box sx={styles.mainContainer}>

            {dataLoading && <LoadBar />}
            {chatbotLoading && <ChatBotLoader />}

            <Box sx={styles.sidebar}>
                <SubSidebar
                    handleMenuChange={handleMenuChange}
                    setSelectedMenuItem={setSelectedMenuItem}
                    selectedMenuItem={selectedMenuItem}
                    unlockedSteps={unlockedSteps}
                />
            </Box>
            <main style={styles.componentContainer}>
                <Box sx={styles.cardContainer}>
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate
                                to="analytics-tool/chatbot-home"
                                replace
                            />}
                        />
                        <Route
                            path="analytics-tool/chatbot-home"
                            element={<GeneralSettings
                                action_type={'create'}
                                onNext={handleNext}
                                onCancel={handleCancel}
                            />}
                        />
                        <Route
                            path="analytics-tool/datasets"
                            element={<ChatbotDataset
                                action_type={'create'}
                                dataLoading={dataLoading}
                                datasets={datasets}
                                getDatasets={getDatasets}
                                datasetLoading={datasetLoading}
                                onNext={handleNext}
                                onCancel={handleCancel}
                            />}
                        />
                        <Route
                            path="analytics-tool/branding"
                            element={<ChatbotBranding
                                action_type={'create'}
                                onCancel={handleCancel}
                                onNext={handleNext}
                            />}
                        />
                        <Route
                            path="analytics-tool/security"
                            element={<ChatbotAuthentication
                                action_type={'create'}
                                allTokens={allTokens}
                                datasets={datasets}
                                dataLoading={dataLoading}
                                tokenLoading={tokenLoading}
                                getAllTokensDetails={getAllTokensDetails}
                                onCancel={handleCancel}
                                onNext={handleNext}
                            />}
                        />
                        <Route
                            path="analytics-tool/test-launch"
                            element={<ChatbotLaunch
                                action_type={'create'}
                                dataLoading={dataLoading}
                                onChatbotToggle={handleChatbotToggle}
                                onSave={handleSave}
                                onCancel={handleCancel}
                            />}
                        />
                    </Routes>
                </Box>
            </main>
        </Box>
    )
}

export default AddChatbot;